import { createActions, createReducer } from "reduxsauce";
export const { Types, Creators } = createActions({
    setNotas: ["payload"],
    setNotaSele: ["payload"],
    onExcluir: ["payload"],
    onEditar: ["payload"],
    onEditarNovo: ["payload"],
    buscarNota: ["payload"],
    buscarNotaSucesso: ["payload"],
    setBucketImgs: ["payload"],
    addBucketImgs: ["payload"],
    reloadTabelaPesq: ["payload"],
});

const INIT_STATE = {
    filtros: {},
    notas: [],
    tabelaNotas: {
        dados: [],
    },
    notaSele: {},
    reloadTabela: [],
    bucketImgs: [],
};
const setNotas = (state = INIT_STATE, action) => ({
    ...state,
    tabelaNotas: {
        dados: action.payload,
    },
});
const setNotaSele = (state = INIT_STATE, action) => ({
    ...state,
    notaSele: action.payload,
});
const onEditar = (state = INIT_STATE, action) => {
    let payload = action.payload;

    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados: novasNotas.slice(),
        },
        notaSele: nota,
    };
};
const onEditarNovo = (state = INIT_STATE, action) => {
    const { nota, notas, substituir } = action.payload;

    let dados = [];

    const ar = notas;

    dados = state.tabelaNotas.dados.map((element) =>
        element.ar === ar ? { ...element, ...substituir } : element
    );

    return {
        ...state,
        tabelaNotas: {
            ...state.tabelaNotas,
            dados,
        },
        notaSele: nota,
    };
};
const onExcluir = (state = INIT_STATE, action) => {
    let payload = action.payload;

    let nota = {
        ...payload.nota,
        historico: payload.novaNota.historico_nota,
        status: payload.novaNota.status_nota,
        situacaoNota: payload.novaNota.situacao_atual,
    };

    let novasNotas = state.tabelaNotas.dados.map((item) =>
        item.ar_nota === payload.novaNota.ar_nota ? nota : item
    );

    return {
        ...state,
        tabelaNotas: {
            dados: novasNotas,
        },
        notaSele: nota,
    };
};
const setBucketImgs = (state = INIT_STATE, action) => ({
    ...state,
    bucketImgs: action.payload,
});
const reloadTabelaPesq = (state = INIT_STATE, action) => ({
    ...state,
    reloadTabela: action.payload,
});
const addBucketImgs = (state = INIT_STATE, action) => {
    const { bucketImgs } = state;
    let novoBucketImgs = { ...bucketImgs, ...action.payload };

    return {
        ...state,
        bucketImgs: novoBucketImgs,
    };
};
const buscarNotaSucesso = (state = INIT_STATE, action) => ({
    ...state,
    notaSele: {
        ...state.notaSele,
        ...action.payload,
    },
});

export default createReducer(INIT_STATE, {
    [Types.SET_NOTAS]: setNotas,
    [Types.SET_NOTA_SELE]: setNotaSele,
    [Types.ON_EDITAR]: onEditar,
    [Types.ON_EDITAR_NOVO]: onEditarNovo,
    [Types.ON_EXCLUIR]: onExcluir,
    [Types.BUSCAR_NOTA_SUCESSO]: buscarNotaSucesso,
    [Types.SET_BUCKET_IMGS]: setBucketImgs,
    [Types.ADD_BUCKET_IMGS]: addBucketImgs,
    [Types.RELOAD_TABELA_PESQ]: reloadTabelaPesq,
});
